export const PROVIDER_NAME = 'Pascal Gaming';

export const GAME_MODES = {
  MOBILE: 'MOBILE',
  MOBILE_LANDSCAPE: 'MOBILE_LANDSCAPE',
  DESKTOP: 'DESKTOP',
};

export const GAME_SCENE = {
  MAIN: 'MAIN',
  PRE_BONUS: 'PRE_BONUS',
  BONUS: 'BONUS',
};

export const FONT_BALOO_NAME = 'Baloo 2';
export const FONT_LATO_NAME = 'Lato';

export const BONUS_AMOUNT_MULTIPLE = 100;

export const BALANCE_UPDATE_DELAY = 6000;

export const PAGE_TAB_IN_ACTIVE_TIME = 1_800_000;

export const FUN_BALANCE_AMOUNT_VALUE = 1_000_000_000;

export const PLAYING_GAME_MODE = {
  REAL: 'REAL',
  DEMO: 'DEMO',
};

export const notificationStatus = {
  Error: 'error',
  Success: 'success',
};

export const QUICK_BETS = [10, 50, 100, 500, 1_000, 3_000, 5_000, 10_000, 20_000, 50_000, 100_000, 300_000, 500_000];

export const RtlLanguages = ['fa', 'ar', 'per', 'ara'];

export const PostMessageListenerMessages = {
  UpdateBalance: 'updateBalance',
  StopAutoSpins: 'stopAutospins',
  AuthInfoUpdate: 'authInfoUpdate',
};

export const PostMessage = {
  Reload: 'reload',
  Logout: 'logout',
  PgGetAuthInfo: 'pgGetAuthInfo',
  PgGameLoaded: 'pgGameLoaded',
  PgLogin: 'pgLogin',
  RedirectLogin: 'redirectLogin',
  RedirectHome: 'redirectHome',
  TogglePlayMode: 'togglePlayMode',
};